/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { ScanFrameIcon16Light } from './ScanFrameIcon16Light';
import { ScanFrameIcon16Regular } from './ScanFrameIcon16Regular';
import { ScanFrameIcon16Solid } from './ScanFrameIcon16Solid';
import { ScanFrameIcon20Light } from './ScanFrameIcon20Light';
import { ScanFrameIcon20Regular } from './ScanFrameIcon20Regular';
import { ScanFrameIcon20Solid } from './ScanFrameIcon20Solid';
import { ScanFrameIcon24Regular } from './ScanFrameIcon24Regular';
import { ScanFrameIcon24Solid } from './ScanFrameIcon24Solid';
import { ScanFrameIcon32Regular } from './ScanFrameIcon32Regular';
import { ScanFrameIcon64Regular } from './ScanFrameIcon64Regular';
var sizes = {
    16: {
        light: ScanFrameIcon16Light,
        regular: ScanFrameIcon16Regular,
        solid: ScanFrameIcon16Solid,
    },
    20: {
        light: ScanFrameIcon20Light,
        regular: ScanFrameIcon20Regular,
        solid: ScanFrameIcon20Solid,
    },
    24: {
        regular: ScanFrameIcon24Regular,
        solid: ScanFrameIcon24Solid,
    },
    32: {
        regular: ScanFrameIcon32Regular,
    },
    64: {
        regular: ScanFrameIcon64Regular,
    },
};
export var ScanFrameIcon = forwardRef('ScanFrameIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
